// 公司列表数据
import ynythgf1 from '../../public/images/swiper/ynythgf/ynythgf-1.jpg'
import ynythgf2 from '../../public/images/swiper/ynythgf/ynythgf-2.jpg'
import cqgj1 from '../../public/images/swiper/cqgjfhclgf/cqgjfhclgf-1.jpg'
import cqgj2 from '../../public/images/swiper/cqgjfhclgf/cqgjfhclgf-2.jpg'
import cqgj3 from '../../public/images/swiper/cqgjfhclgf/cqgjfhclgf-3.jpg'
import cqgj4 from '../../public/images/swiper/cqgjfhclgf/cqgjfhclgf-4.jpg'
import cqgj5 from '../../public/images/swiper/cqgjfhclgf/cqgjfhclgf-5.jpg'
// 其他公司图片（全部引入，后续按需使用）
import ynythxxkj1 from '../../public/images/swiper/ynythxxkj/ynythxxkj-1.jpg'
import ynythxxkj2 from '../../public/images/swiper/ynythxxkj/ynythxxkj-2.jpg'
import ynythxxkj3 from '../../public/images/swiper/ynythxxkj/ynythxxkj-3.jpg'
import ynythxxkj4 from '../../public/images/swiper/ynythxxkj/ynythxxkj-4.jpg'

import ynythsh1 from '../../public/images/swiper/ynythsh/ynythsh-1.jpg'
import ynythsh2 from '../../public/images/swiper/ynythsh/ynythsh-2.jpg'
import ynythsh3 from '../../public/images/swiper/ynythsh/ynythsh-3.jpg'
import ynythsh4 from '../../public/images/swiper/ynythsh/ynythsh-4.jpg'

import ynythcw1 from '../../public/images/swiper/ynythcw/ynythcw-1.jpg'
import ynythcw2 from '../../public/images/swiper/ynythcw/ynythcw-2.jpg'
import ynythcw3 from '../../public/images/swiper/ynythcw/ynythcw-3.jpg'

import yntahg1 from '../../public/images/swiper/yntahg/yntahg-1.jpg'
import yntahg2 from '../../public/images/swiper/yntahg/yntahg-2.jpg'
import yntahg3 from '../../public/images/swiper/yntahg/yntahg-3.jpg'
import yntahg4 from '../../public/images/swiper/yntahg/yntahg-4.jpg'

import ynsfyth1 from '../../public/images/swiper/ynsfyth/ynsfyth-1.jpg'
import ynsfyth2 from '../../public/images/swiper/ynsfyth/ynsfyth-2.jpg'
import ynsfyth3 from '../../public/images/swiper/ynsfyth/ynsfyth-3.jpg'
import ynsfyth4 from '../../public/images/swiper/ynsfyth/ynsfyth-4.jpg'
import ynsfyth5 from '../../public/images/swiper/ynsfyth/ynsfyth-5.jpg'

import ynlhjt1 from '../../public/images/swiper/ynlhjt/ynlhjt-1.jpg'
import ynlhjt2 from '../../public/images/swiper/ynlhjt/ynlhjt-2.jpg'
import ynlhjt3 from '../../public/images/swiper/ynlhjt/ynlhjt-3.jpg'
import ynlhjt4 from '../../public/images/swiper/ynlhjt/ynlhjt-4.jpg'

import ythlhsw1 from '../../public/images/swiper/ythlhsw/ythlhsw-1.jpg'
import ythlhsw2 from '../../public/images/swiper/ythlhsw/ythlhsw-2.jpg'

import ythgfyfzx1 from '../../public/images/swiper/ythgfyfzx/ythgfyfzx-1.jpg'
import ythgfyfzx2 from '../../public/images/swiper/ythgfyfzx/ythgfyfzx-2.jpg'
import ythgfyfzx3 from '../../public/images/swiper/ythgfyfzx/ythgfyfzx-3.jpg'
import ythgfyfzx4 from '../../public/images/swiper/ythgfyfzx/ythgfyfzx-4.jpg'

import ynythnzls1 from '../../public/images/swiper/ynythnzls/ynythnzls-1.jpg'
import ynythnzls2 from '../../public/images/swiper/ynythnzls/ynythnzls-2.jpg'
import ynythnzls3 from '../../public/images/swiper/ynythnzls/ynythnzls-3.jpg'
import ynythnzls4 from '../../public/images/swiper/ynythnzls/ynythnzls-4.jpg'

import cqythtjxcl1 from '../../public/images/swiper/cqythtjxcl/cqythtjxcl-1.jpg'
import cqythtjxcl2 from '../../public/images/swiper/cqythtjxcl/cqythtjxcl-2.jpg'
import cqythtjxcl3 from '../../public/images/swiper/cqythtjxcl/cqythtjxcl-3.jpg'
import cqythtjxcl4 from '../../public/images/swiper/cqythtjxcl/cqythtjxcl-4.jpg'

// 移除 companyList，直接在组件中通过 companyDetails 构造列表

// 公司详细信息
export const companyDetails = {
    'ythjt': {
        title:"云天化集团有限责任公司",
        description:
            ['云天化集团是以肥料产业、玻纤及复合材料、化工新材料为主业的综合性产业集团，是全球领先的磷肥、氮肥、玻纤、共聚甲醛制造商。',
                '肥料产业，化肥总产能1200万吨/年、其中磷复肥产能1000万吨/年，位居全球前列，已贯通从资源端到消费端的全产业链，承担着为“保障国家粮食安全”提供肥料供应的重要职责；玻纤及复合材料，玻纤产能约121万吨/年，产能全国第三、全球第四，其中风电产品领域材料保持领先，多款新产品为行业首创；化工新材料，主要涵盖新能源材料、精细磷化工、氟化工、石油化工、工程材料、电子新材料等领域，其中聚甲醛产品在国内聚甲醛市场占有率20%左右，产能位居全国第一。'
            ],
        images: [
        ],
        jobSearchTag: "26541c5a99d55aa782ea35e314bd19cd"
    },
    'ynthgf': {
        title:"云南云天化股份有限公司",
        description:
            ['云南云天化股份有限公司是云天化集团有限责任公司的控股上市公司（证券代码:600096），主营肥料、磷矿采选、精细化工、商贸物流等产业，磷矿采选能力、聚甲醛产能规模均居全国前列，磷复肥产能规模居亚洲前列。',
                '公司旗下拥有30余家分子公司，员工总数超过1万人，在云南、重庆、内蒙古等省市建有生产基地，在中东、东南亚地区设立了销售公司，销售网点分布于世界各地。公司先后入选国务院国资委国有重点企业“管理标杆企业”、国有企业“公司治理示范企业”，商务部全国供应链创新与应用“百强示范企业”。'
            ],

        contact: {
            person: '李老师',
            phone: '0871-64327162',
            address: '云南省昆明市滇池路1417号',
            website: 'https://www.yyth.com.cn/'
        },
        images: [
            ynythgf1,
            ynythgf2
        ],
        // jobSearchTag: "51948d7f2b2c30f95af362b56ac35c8a"
        jobSearchTag: "eff12259fc6edd30aea8e2e389bcac26"
    },
    'ynsfyth': {
        title:"云南水富云天化有限公司",
        description:
            ['云南水富云天化有限公司是云南云天化股份有限公司的全资子公司，2013年6月注册成立。公司拥有年产50万吨合成氨、80万吨尿素、26万吨甲醇、10万吨液态二氧化碳、10万吨车用尿素、3万吨聚甲醛、1万吨季戊四醇的生产能力。“金沙江”牌尿素是国内大化肥行业的名优产品和云南省首批名牌产品，两次蝉联国优金奖，各项质量指标均达到了国家优级品标准，“云天化”牌聚甲醛、季戊四醇是“云南名牌”产品。',
                '水富云天化秉承“长青基业，人为其本；精益生产，达于至善”的管理理念，围绕“集团重要生产基地、集团氮肥人才培养基地、对接新能源市场前沿基地”建设，发挥“党建引领、生产运营、安全环保、装备维护、廉洁保障”五大优势，构筑“传统化工+新兴产业”双轮驱动的产业新格局，以一流的人才、一流的产品、一流的服务和一流的效益，努力成为行业领先者和客户首选。'
            ],
        contact: {
            person: '侯老师',
            phone: '17842407243',
            address: '云南省水富市云富街道办事处云天大道37号'
        },
        images: [
            ynsfyth1,
            ynsfyth2,
            ynsfyth3,
            ynsfyth4,
            ynsfyth5,
        ],
        jobSearchTag: "354cf25866339f1b3e2a2edd846b5fd5"
    },
    'ynlhjt': {
        title:"云南磷化集团有限公司",
        description:
            ['云南磷化集团有限公司是云南云天化股份有限公司的全资子公司，总部位于美丽的滇池之畔—云南省昆明市晋宁区。公司是集地质勘查、矿山建设、技术研发、磷矿采选、磷化工、育种育苗和仓储物流为一体的高新技术企业，在岗员工2000余人，资产总计78.9亿元。公司依托雄厚的磷矿资源实力，建设有四座大型矿山，3套磷矿擦洗装置和2套磷矿浮选装置。建设有1套产能80万吨/年硫酸、30万吨/年磷酸、50万吨/年饲料级磷酸钙盐的大型磷化工生产装置。公司拥有国家磷资源开发利用工程技术研究中心，建设有云南省磷矿采选工程技术研究中心、云南省磷资源技术创新中心、云南省磷产业制造业创新中心、院士工作站、博士后科研工作站。公司致力于打造成为国际一流磷矿采选企业、国内绿色饲料添加剂领军者、云南省固废资源化利用先行者。'
            ],
        contact: {
            person: '孙老师',
            phone: '18208726145',
            address: '云南省昆明市晋宁区昆阳街道永乐大街403号'
        },
        images: [
            ynlhjt1,
            ynlhjt2,
            ynlhjt3,
            ynlhjt4,
        ],
        jobSearchTag: "91e314281ca9315ca1ac08d4ce13ca68"
    },
    'yntahg': {
        title:"云南天安化工有限公司",
        description:
            ['云南天安化工有限公司（简称天安化工）成立于2003年11月，是云天化集团有限责任公司三级公司、云南云天化股份全资子公司，拥有年产高浓度磷复肥182万吨、湿法磷酸70万吨、硫酸220万吨、合成氨50万吨的生产装置，并建有水、电、气、铁路运输等配套完善的公用工程配套设施，是国内目前规模最大的高浓度磷复肥和磷化工生产基地之一。公司主厂区占地面积2080亩。',
                '天安化工经过20年的发展和持续不断的创新，已经建立了从上到下完整的产业链和多元化的产品结构，目前公司主要产品有磷酸一铵、磷酸二胺、水溶肥、氟硅酸钠、电池级MAP、精制磷酸，中间产品有液氨、液氮、液氩、磷酸、硫酸、双氧水。公司承接了云天化集团成为保障粮食安全的“国家队”和先进制造业“标杆企业”两个战略定位，以“粮安天下、制造美好”为使命，构建了“矿-酸-肥、矿-酸-化”双轮驱动发展格局，建立了从上到下完整产业链和多元化产品结构。'
            ],
        contact: {
            person: '高老师',
            phone: '0871-68750141',
            address: '云南省昆明市安宁市草铺工业园区'
        },
        images: [
            yntahg1,
            yntahg2,
            yntahg3,
            yntahg4,
        ],
        // jobSearchTag: "a901edfab09a5cdda50192d2e0357271"
        jobSearchTag: "39b43247a33e9ad516bef50213c98bd4"
    },
    'ynythgf': {
            title:"云南云天化股份有限公司研究院",
            description:
                ['云南云天化股份有限公司研究院（简称"云天化研究院"或"研究院"）成立于2024年10月，是云南云天化股份有限公司（简称"云天化股份"）集约化、扁平化、一体化研发机构，是肥料、氟硅、磷资源等产业的科技创新管理平台，是推动云天化股份战略转型、结构调整的"动力源"。云天化研究院聚焦肥料、磷资源、氟硅及化学品等核心技术创新领域，集成优势科研资源，优化技术创新布局，实施技术领先策略，加快突破关键核心技术，以"创新链"赋能"产业链"，推动云天化绿色高质量发展。'
                ],
        contact: {
            person: '唐老师',
            phone: '0871-67362683',
            address: '云南省昆明市滇池路1417号'
        },
        images: [
            ythgfyfzx1,
            ythgfyfzx2,
            ythgfyfzx3,
            ythgfyfzx4,
        ],
        // jobSearchTag: "6aa5d3acc46239694c57918e4bf91bb3"
        jobSearchTag: "a0c0044a5af2d414e7178ead584bf973"
    },
    'ynythlhsw': {
        title:"云南云天化联合商务有限公司",
        description:
            ['云南云天化联合商务有限公司（简称公司），成立于2003年，是云天化股份下属专业的商贸物流企业，是云天化集团实施国际化战略的重要平台。',
                '公司主营业务包括肥料产品、能源化学品，全球化肥运营规模超300万吨，硫磺200万吨，年物流运营规模达1600万吨以上，连续七年成为中国国际进口博览会云南交易团最大现场进口签约企业。公司在新加坡、阿联酋、缅甸、美国、秘鲁等国设立了境外子公司，在缅甸建立了种植示范中心，营销业务已服务至全球30多个国家和地区，具有良好的全球化营销与服务能力。'
            ],
        contact: {
            person: '丁老师',
            phone: '0871-64322311',
            address: '云南省昆明市滇池路1417号'
        },
        images: [
            ythlhsw1,
            ythlhsw2
        ],
        // jobSearchTag: "01d163f9959060ba7dfe60340a0ea95c"
        jobSearchTag: "277ff89e5f6cab7b18432382d8927f7b"
    },
    'ynythnzls': {
        title:"云南云天化农资连锁有限公司",
        description:
            ['云南云天化农资连锁有限公司（简称云天化连锁）是云天化股份（大型国有上市公司）旗下控股子公司，注册资本7.5亿元。',
                '作为云南省农资流通领域的龙头企业，公司先后荣获“中国农资流通行业最具价值品牌”、“云南省农资流通领域龙头企业”、“云南省十佳农资企业”、“农民信赖的好品牌”等荣誉。在激烈的市场角逐中，公司坚持以市场为导向，依托云天化丰富的产品资源和品牌优势深耕市场，搭建农资电商平台，构建三级农化服务体系，致力于提供作物全程解决方案，实现以渠道为核心的深度营销模式转型升级。',
                '公司坚持绿色科技,服务现代农业。始终遵循“在为客户创造价值中创造价值”的经营理念，为实现“让土地用上好肥料，与合作伙伴共成长”的发展愿景，以“立根大地、服务田间、与您携手、志搏云天”的服务理念，全力打造与客户成为事业共同体和命运共同体，以一流的人才、一流的产品和一流的服务，努力成为行业引领者和客户首选。'
            ],
        contact: {
            person: '叶老师',
            phone: '13638865857',
            address: '云南省昆明市国家旅游度假区金柳路11号'
        },
        images: [
            ynythnzls1,
            ynythnzls2,
            ynythnzls3,
            ynythnzls4,
        ],
        // jobSearchTag: "5c5d7ff2328fadd02ec57d3fbc6d3ceb"
        jobSearchTag: "c46b9a93520b0e71d6fac7a4b84e5eb8"
    },
    'cqythtjxcl': {
        title:"重庆云天化天聚新材料有限公司",
        description:
            ['重庆云天化天聚新材料有限公司（以下称：天聚新材）是一家集共聚甲醛产品研发、生产、销售于一体的化工新材料制造企业，是云南云天化股份有限公司的全资子公司,在重庆长寿区和云南水富市拥有两个生产基地，公司有员工510余人。公司主要产品产能：共聚甲醛9万吨/年（含水富基地3万吨）、改性材料1万吨/年、季戊四醇1万吨/年。目前，公司共聚甲醛产品产能和市场占有率在国内均处于领先地位。',
                '公司秉承“聚天地精华，创万物生机”的企业使命，用“‘卓越’坚守‘卓越’”的管理理念，“永不言弃，创新不止”的创新理念，不断向“做世界一流聚甲醛供应商”的企业愿景迈进。'
            ],
        contact: {
            person: '邓老师',
            phone: '023-40717286',
            address: '重庆市长寿区经济技术开发区化南路3号'
        },
        images: [
            cqythtjxcl1,
            cqythtjxcl2,
            cqythtjxcl3,
            cqythtjxcl4,
        ],
        // jobSearchTag: "34827faa6169a5f7b30be9023e218f59"
        jobSearchTag: "cfbc9591e489283beaa5555ebeea1ede"
    },
    'ynythxxkj': {
        title:"云南云天化信息科技有限公司",
        description:
            ['云南云天化信息科技有限公司隶属于云天化集团，于2016年11月在云南昆明注册成立，是一家专业聚焦工业互联网产品研发与实施、人工智能研究与应用、ERP咨询与实施、云基础设施建设与运维，集方案提供与实施服务于一体的综合性信创企业。',
                '云天化信息作为云天化集团数字化转型的技术承载者，拥有“数字工厂平台、健康安全环保管理系统、工业互联网应用开发平台”等多个自主知识产权平台。公司秉承“为客户创造价值”的企业使命，为政府、企业数字化赋能，致力于发展成为工业领域数字化转型升级的优秀服务商。'
            ],
        contact: {
            person: '和老师',
            phone: '0871-64333514',
            address: '昆明市西山区滇池路1417号',
            email:'492616326@qq.com'
        },
        images: [
            ynythxxkj1,
            ynythxxkj2,
            ynythxxkj3,
            ynythxxkj4
        ],
        // jobSearchTag: "cff5545f4bd934c16c3f228cda3a37b5"
        jobSearchTag: "5940f7f0f9b1fbf8b4e5ea4b9005d35a"
    },
    'ynythjtcw': {
        title:"云南云天化集团财务有限公司",
        description:
            ['云南云天化集团财务有限公司成立于2013年10月10日，是云天化集团有限责任公司控股子公司。公司本着“一个服从、两个服务、三个改善、四个平台”的经营宗旨，为成员单位提供全方位、多层次的金融服务。二〇三五年公司远景目标是通过集约化、市场化资金管理，构建集团化信息系统管理平台、建立健全集团化资金管理机制、优化资金资源配置、提升资金运营管理效率、降低财务成本、优化资产负债结构、防范资金风险，打造懂金融、懂产业、懂管理的复合型、创新型优秀人才队伍，助推集团绿色高质量发展，实现全产业链管理协同、全价值链效益提升。全力助推云天化集团成为世界一流的具有国际竞争力的绿色产业集团。成为集团“战略决策的金融参谋者”，成为集团“生产经营的现金支持者”，成为集团“运营状况的资金监测者”。'
            ],
        contact: {
            person: '杨老师',
            phone: '0871-64332927',
            address: '昆明市西山区滇池路1417号'
        },
        images: [
            ynythcw1,
            ynythcw2,
            ynythcw3,
        ],
        // jobSearchTag: "b97776d3ee7d8d20f7cf3f8db65d3429"
        jobSearchTag: "3f11ca075f8c03bd7c41335ae48efe48"
    },
    'ynythsh': {
        title:"云南云天化石化有限公司",
        description:
            ['云南云天化石化有限公司成立于2012年8月22日，注册资本11.08亿元。公司是以云南千万吨级炼油基地提供的LPG、丙烯为依托，按照“一体化、规模化、原料全部就地转化”原则进行下游深加工的石化企业。',
                '目前公司已建成并生产运行“年产25万吨聚丙烯装置”“年产34万吨工业异辛烷装置”“3×220吨/小时热电联产装置”及“1.5万吨/年液氨精制装置”。其中，聚丙烯及异辛烷装置的建成投产，填补了云南省石化产业空白；异辛烷装置产品质量、消耗等指标达到行业标杆水平。'
            ],
        contact: {
            person: '杨老师',
            phone: '13518721520',
            address: '昆明市安宁草铺镇云南云天化石化有限公司'
        },
        images: [
            ynythsh1,
            ynythsh2,
            ynythsh3,
            ynythsh4
        ],
        // jobSearchTag: "52aa8ced88e4b5078c9d1aa370e8d746"
        jobSearchTag: "de3f7e896a89aea9088c7cfc5f744a3f"
    },
    'cqgjfhclgf': {
        title:"重庆国际复合材料股份有限公司",
        description:
            ['重庆国际复合材料股份有限公司（以下简称“公司”）成立于1991年，主板上市企业（股票代码：301526），公司总部位于重庆市大渡口区，是云天化集团旗下玻纤及复合材料产业板块的重要支柱企业。公司专注于高性能新材料，致力于研制品质稳定、持续创新的高性能产品，为客户提供更具价值的服务和应用解决方案，是一家以研发、生产、销售玻璃纤维及复合材料为核心业务的高新技术企业。',
                '经过30余年的不断发展，公司现在全球拥有7个生产基地、17条玻纤池窑生产线，玻纤年产能超120万吨，产能规模位居全球前三，在清洁能源、节能减排、5G通讯等核心业务领域居于全球领先地位。公司营销网络遍布全球，在美国、荷兰和香港等设立贸易子公司，产品畅销全球数十个国家和地区，与国内外知名企业建立了长期稳定的战略合作关系。未来公司将坚持“卓越运营”、“产品创新”、“纤材协同”等三大战略发展主题，抢抓绿色能源、汽车轻量化、新基建、节能建筑、电子通信发展机遇，全面提升企业的核心竞争力，向成为全球最具价值的玻璃纤维及复合材料企业不断努力迈进。'
            ],
        contact: {
            person: '王老师',
            phone: '（023）68157855',
            address: '重庆市大渡口区建桥工业园B区',
            email:'cpiczp@cpicfiber.com',
            website: 'http://www.cpicfiber.com'
        },
        images: [
            cqgj1,
            cqgj2,
            cqgj3,
            cqgj4,
            cqgj5
        ],
        // jobSearchTag: "4ad63279013c022cea16e195cbb2e383"
        jobSearchTag: "6478627a5f73f2dd67c22a2798edb3bd"
    },
    'cqythhexclkf': {
        title:"重庆云天化瀚恩新材料开发有限公司",
        description:
            ['重庆云天化瀚恩新材料开发有限公司是云天化集团全资子公司，是一家集新材料研发、生产、销售于一体的国家高新技术企业，主要从事领域为光电子显示材料、环保新材料、高性能散热材料。它的前身是支撑云天化产业升级、结构调整的研发机构——云天化重庆研发中心。2016年初，研发机构独立法人化，在长寿区注册成立了重庆云天化瀚恩新材料开发有限公司，是重庆市研发机构法人化的第一家企业。',
                '公司注册资本2亿元，占地115亩，总建筑面积6.4万m2，研发和试验仪器/设备共850台/套。是重庆市长寿经济技术开发区博士后科研工作站，公司检测中心获得国家合格评定认可委员会(CNAS)认可资质，现为长寿经开区公共检测平台依托单位。'
            ],

        // jobSearchTag: "f795b9310deef9e06620a331ffce9b58"
        jobSearchTag: "930ee7a00d23f73c6466a3518bc3716e"
    },
    'cqtyclkj': {
        title:"重庆天寰材料科技有限公司",
        description:
            ['重庆天寰材料科技有限公司（简称重庆天寰，原上海天寰材料科技有限公司）成立于2015年3月23日，位于重庆市大渡口区，是重庆国际复合材料股份有限公司旗下致力于新材料研发、生产、销售、售后为一体的全资子公司，是集团国有企业改革的试验田，注册资本3亿元人民币，总资产30亿元人民币，年营业额18-22亿元人民币，是一家大中型国有企业，现有职工1000余人',
                '公司致力于电子级玻璃纤维纱/玻璃纤维布，HL（低介电）细纱/玻纤布和工业级玻纤纱/玻纤布的研发、生产及销售。公司实现了纱布一体，下属三家子公司：重庆天勤材料有限公司、珠海珠玻电子材料有限公司。',
                '总生产规模年产上万吨高端优质玻璃纤维纱和20000万米玻璃纤维布。产品面向国内外市场，销往华东、华南、台湾、韩国、日本、美国、欧洲等地。公司将不断适应全球经济调整格局，继续积极主动的实施国际化、一体化布局，以市场和客户服务为落脚点，不断追求创新与卓越，向全球电子玻纤行业国际化的优秀供应商的目标努力迈进。'
            ],
        contact: {
            address: '重庆长寿、广东珠海',
        },
        // jobSearchTag: "e70f003f544fb534656c428cdc4fd6eb"
        jobSearchTag: "abbac17dd2f38c2f71c6f15ade666f74"
    },
    'ynyjnxcl': {
        title:"云南云聚能新材料有限公司",
        description: ['云南云聚能新材料有限公司（以下简称：聚能新材）是云天化股份控股，友山新材料参股的合资公司，位于昆明市安宁市。主要经营业务为新材料技术研发、推广服务及新材料产品的生产及销售。',
        '聚能新材依托于云天化集团磷资源、磷化工、精细磷化工、新能源材料及自主研发的全产业链优势，形成研发、建设、生产、销售一体化的高效运营模式，实现新能源电池正极材料前驱体磷酸铁的生产，产品稳定且一致性强、杂质含量低、生产成本优势明显，是优质的高端正极前驱体材料。'],
        contact: {
            person: '刘老师',
            phone: '18083877790',
            address: '云南省昆明市安宁市草铺工业园区'
        },
        jobSearchTag: "0485953f3944e6ecbf4060d35d19054f"
    }
};